<div class="p-wrapper-custom pagination-order py-5 single-right-pagination">
  <header
    class="samplepo-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>{{ heading }}</h1>
    <div class="samplepo-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="pi pi-cloud-upload icon-blue mx-1"></i>
        <a class="link" (click)="exportReport()">Export excel</a>
      </div>
    </div>
  </header>

  <p-table
    #dt
    responsiveLayout="scroll"
    [value]="amountList"
    styleClass="p-datatable-customers"
    [rowHover]="true"
    [rows]="20"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 20, 50, 1000]"
    [paginator]="amountList.length >= 20"
    [autoLayout]="true"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center">CB Days</th>
        <th class="text-center">Invoice</th>
        <th class="text-center">Client</th>
        <th class="text-center">Job Name</th>
        <th class="text-center">Total Amt</th>
        <th class="text-center">Open Amt</th>
      </tr>
      <tr>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="cbDays"
              id="cbDays"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'cbDays', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="invoice"
              id="invoice"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'invoice', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="client"
              id="client"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'client', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="jobName"
              id="jobName"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'jobName', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="totalAmount"
              id="totalAmount"
              style="max-width: 200px"
              (input)="
                dt.filter(
                  $any($event.target).value,
                  'totalAmount',
                  'startsWith'
                )
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
        <th>
          <div class="d-flex">
            <input
              jniAutoCompleteBlocker
              pInputText
              type="text"
              name="openAmount"
              id="openAmount"
              style="max-width: 200px"
              (input)="
                dt.filter($any($event.target).value, 'openAmount', 'startsWith')
              "
              placeholder=""
              class="p-column-filter p-inputtext p-component" />
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-amountList let-rowIndex="rowIndex">
      <tr>
        <td>{{ amountList.cbDays }}</td>
        <td>{{ amountList.invoice }}</td>
        <td>{{ amountList.client }}</td>
        <td>
          <a class="link" (click)="redirectToSummary(amountList.salesId)">{{
            amountList.jobName
          }}</a>
        </td>
        <td class="align-right">
          {{ amountList.totalAmount | number: "1.2-2" }}
        </td>
        <td class="align-right">
          {{ amountList.openAmount | number: "1.2-2" }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="30">No Data Found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
